import React from 'react';
import PropTypes from 'prop-types';

import * as S from './style';
import TextInput from './text-input';

const OtherTextInput = ({ name, error, touched, t, tkey }) => (
  <S.OtherTextInput>
    <S.Label style={{ flex: '1 1 100%' }}>{t(tkey)}</S.Label>
    <TextInput name={name} error={error} touched={touched} />
  </S.OtherTextInput>
);

export default OtherTextInput;

OtherTextInput.propTypes = {
  name: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  t: PropTypes.any,
  tkey: PropTypes.string,
};
